import { Card, CardContent, TextField, Typography, Button, Modal } from '@mui/material'
import styles from './ExternCard.module.css' // Importamos los estilos
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import InviteExternalModal from './InviteExternalModal'
import { LangType } from 'common/enums/LangType'

// Definimos la interfaz de los props
interface CardComponentProps {
  inputValue: string
  setInputValue: (value: string) => void
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void
  handlerAddUser: () => void
  language: LangType
  setLanguage: (value: LangType | Number) => void
}

export default function CardComponent({
  inputValue,
  setInputValue,
  onSubmit,
  handlerAddUser,
  language,
  setLanguage,
}: CardComponentProps) {
  const [startingOptions, setStartingOptions] = useState<boolean>(true)
  const [externInviteSelected, setExternInviteSelected] = useState<boolean>(false)

  const { t } = useTranslation()

  const handleInviteExtern = () => {
    setExternInviteSelected(true)
  }

  const handleCloseInviteModal = () => {
    setExternInviteSelected(false)
    setStartingOptions(true)
  }

  return (
    <Card className={styles.card}>
      <CardContent className={styles.cardContent}>
        {startingOptions && (
          <>
            <Button
              variant="contained"
              color="secondary"
              className={styles.submitButton}
              onClick={handlerAddUser}
            >
              {t('createProfessional')}
            </Button>
            <Button
              variant="contained"
              color="secondary"
              className={styles.submitButton}
              onClick={handleInviteExtern}
            >
              {t('externInvite')}
            </Button>
          </>
        )}

        <Modal open={externInviteSelected}>
          <InviteExternalModal
            inputValue={inputValue}
            setInputValue={setInputValue}
            onSubmit={onSubmit}
            language={language}
            setLanguage={setLanguage}
            handleCloseModal={handleCloseInviteModal}
          />
        </Modal>
      </CardContent>
    </Card>
  )
}
